import { graphql } from '../../../../graphql/generated';

export const ParameterFragment = graphql(`
  fragment CatalogForm_Parameter on Parameter {
    id
    shortName
    longName
    synonyms
  }
`);
